import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5 22h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 2h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Hourglass";
const Hourglass = memo(themed(Icon));
export {
  Hourglass
};
//# sourceMappingURL=hourglass.js.map
